var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.noticeTitle"), prop: "title" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  type: "text",
                  clearable: "",
                  placeholder: "请输入通知标题",
                  disabled: _vm.isDisabled
                },
                model: {
                  value: _vm.childData.title,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "title", $$v)
                  },
                  expression: "childData.title"
                }
              })
            ],
            1
          ),
          _c("el-form-item", {
            attrs: { label: _vm.$t("table.noticeContent"), prop: "content" }
          }),
          _c(
            "el-form-item",
            { attrs: { label: "通知类型" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { disabled: _vm.isDisabled },
                  model: {
                    value: _vm.childData.isReceipt,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "isReceipt", $$v)
                    },
                    expression: "childData.isReceipt"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "普通通知", value: "0", selected: "" }
                  }),
                  _c("el-option", { attrs: { label: "回执通知", value: "1" } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.receiverObjectName") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { disabled: _vm.isDisabled },
                  on: { change: _vm.receiverObjectTypeChanged },
                  model: {
                    value: _vm.childData.receiverObjectType,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "receiverObjectType", $$v)
                    },
                    expression: "childData.receiverObjectType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "全校教职工", value: "1", selected: "" }
                  }),
                  _c("el-option", {
                    attrs: { label: "全校班主任", value: "5" }
                  }),
                  _c("el-option", {
                    attrs: { label: "全校办公人员", value: "2" }
                  }),
                  _c("el-option", {
                    attrs: { label: "全校教师", value: "3", selected: "" }
                  }),
                  _c("el-option", {
                    attrs: { label: "指定班次学员", value: "4" }
                  }),
                  _c("el-option", {
                    attrs: { label: "自定义选择人员", value: "6" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.showClassList
            ? _c(
                "el-form-item",
                { attrs: { label: "通知班次", prop: "classList" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      attrs: { multiple: "", disabled: _vm.isDisabled },
                      model: {
                        value: _vm.childData.classList,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "classList", $$v)
                        },
                        expression: "childData.classList"
                      }
                    },
                    _vm._l(_vm.classOption, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.trainingShiftName, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.childData.receiverObjectType == 6
            ? _c(
                "el-form-item",
                { attrs: { label: "通知人员", prop: "tzry" } },
                [_c("div", [_vm._v(_vm._s(_vm.childData.receiverObjectName))])]
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "附件" } },
            [
              _c("el-upload", {
                staticClass: "upload-demo",
                attrs: {
                  name: "files",
                  "on-error": _vm.handleError,
                  "on-success": _vm.handleSuccess,
                  action: _vm.uploadUrl,
                  "on-preview": _vm.handlePreview,
                  "on-remove": _vm.handleRemove,
                  "before-remove": _vm.beforeRemove,
                  "before-upload": _vm.beforeUpload,
                  disabled: true,
                  multiple: "",
                  "file-list": _vm.files
                }
              }),
              _c(
                "el-dialog",
                {
                  attrs: {
                    "close-on-click-modal": false,
                    visible: _vm.dialogVisible,
                    title: "预览"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          this.id === -1
            ? _c("el-button", { on: { click: _vm.handCancle } }, [
                _vm._v(_vm._s(_vm.$t("button.cancel")))
              ])
            : _vm._e(),
          this.id === -1
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
                [_vm._v(_vm._s(_vm.$t("button.confirm")))]
              )
            : _vm._e(),
          this.id > 0
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handCancle } },
                [_vm._v(_vm._s(_vm.$t("button.close")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.dialogPreVisible,
            width: "500px",
            title: "图片预览"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogPreVisible = $event
            }
          }
        },
        [
          _c("div", { ref: "picPreview", attrs: { id: "picPreview" } }, [
            _c("img", { attrs: { src: this.picUrl, width: "460px" } })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }